import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import SideBar from "./layout/sidebar/SideBarMenu";
import MainContent from "./layout/main/MainContent";
import { GlobalAppContext } from "./context";
import admin from "./services/adminService";
import firebase from "./services/firebase";
import "./App.scss";
import "./mdb/mdb.css";

function App() {
  const [toggled, setToggled] = useState(false);
  const [pinned, setPinned] = useState(false);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [hasBackground, setHasBackground] = useState(true);
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState("");

  let style = toggled && pinned ? "toggled pinned " : toggled ? "toggled " : "";
  style += hasBackground ? "sidebar-bg " : "";

  let populateUser = (user) => {
    if (user) {
      let data = { ...user };
      data.displayName = user.displayName ? user.displayName : "";
      data.email = data.email ? data.email : "";
      data.photoURL = user.photoURL
        ? user.photoURL
        : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";
      return data;
    }
  };

  useEffect(() => {
    let init = async () => {
      await firebase.isInitialized().then((val) => {
        setUser(populateUser(val));
      });
    };
    const selectedTheme = admin.getTheme();
    setTheme(selectedTheme || "light-theme");
    init();
  }, []);

  useEffect(() => {
    admin.setTheme(theme);
  }, [theme]);

  return (
    <React.Fragment>
      <GlobalAppContext.Provider
        value={{
          toggled,
          setToggled,
          hasBackground,
          setHasBackground,
          pinned,
          setPinned,
          theme,
          setTheme,
          user,
          isSignedIn,
          setIsSignedIn,
          modalOpen,
          setModalOpen,
        }}
      >
        <div className={"page-wrapper bg2 " + style + theme}>
          <SideBar />
          <MainContent />
        </div>
      </GlobalAppContext.Provider>
    </React.Fragment>
  );
}

export default App;
